import { styled } from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
`;

export const ItemContent = styled.div<{
  $themeColor?: string;
  $from?: 'scrollable' | 'event-poster';
}>`
  padding-top: 20px;
  padding-bottom: 20px;
  border-bottom: 4px solid transparent;
  font-size: 2rem;

  @media (max-width: ${({ theme }) => theme.breakpoint.width1550}) {
    font-size: 1.5rem;
  }
`;

export const ItemWrapper = styled.div<{
  $themeColor?: string;
  $from?: 'scrollable' | 'event-poster';
}>`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;

  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
  cursor: pointer;
  color: ${({ theme, $from }) =>
    $from === 'scrollable' ? theme.color.black : theme.color.white};

  padding-left: 2.5rem;
  padding-right: 2.5rem;

  @media (max-width: ${({ theme }) => theme.breakpoint.width1550}) {
    padding-left: 2rem;
    padding-right: 2rem;
  }

  &:hover {
    background-color: ${({ theme, $from }) =>
      $from === 'scrollable' ? theme.color.greyLight : theme.color.white};
    color: ${({ $themeColor }) => $themeColor ?? 'transparent'};

    ${ItemContent} {
      border-bottom: 4px solid
        ${({ $themeColor }) => $themeColor ?? 'transparent'};
    }
  }
`;

export const ItemContentText = styled.div<{ $themeColor?: string }>`
  border-bottom: 2px solid transparent;
  width: 100%;
  height: 100%;
`;

export const HoverBox = styled.div<{
  $themeColor?: string;
  $from?: 'scrollable' | 'event-poster';
  $isVisible?: boolean;
}>`
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  background-color: ${({ theme, $from }) =>
    $from === 'scrollable' ? theme.color.greyLight : theme.color.white};
  border-top: none;
  width: 250px;
  border-bottom-left-radius: 5px;
  border-bottom-right-radius: 5px;
  padding: 1rem;
  z-index: 10;
  opacity: ${({ $isVisible }) => ($isVisible ? 1 : 0)};
  /* transform: translateY(-10px); */
  pointer-events: ${({ $isVisible }) => ($isVisible ? 'auto' : 'none')};
  transition: opacity 0.2s ease;

  ${ItemWrapper}:hover & {
    opacity: ${({ $isVisible }) => ($isVisible ? 1 : 0)};
    transform: translateY(0);
    pointer-events: ${({ $isVisible }) => ($isVisible ? 'auto' : 'none')};
  }
`;
